import { Suspense, useMemo, type FC } from 'react';
import { getColorVar } from '../../../../../../theme';
import type { PriceBoxProps } from '../price.types';
import { ActivityIndicator } from '../../../../../atoms/activity-indicator';
import { FinalPriceSimple } from '../simple';
import { FinalPriceConfigurable } from '../configurable';
import { PriceSizeEnum } from '../price.enum';

export const PriceBox: FC<PriceBoxProps> = props => {
    const { product, PriceProductCard, variantSize = PriceSizeEnum.SMALL } = props;

    const PriceBoxComponent = useMemo(
        () => (product?.__typename === 'SimpleProduct' ? FinalPriceSimple : FinalPriceConfigurable),
        [product?.__typename]
    );

    return (
        <Suspense fallback={<ActivityIndicator size="large" color={getColorVar('primary', '100')} />}>
            {PriceProductCard ?? <PriceBoxComponent {...props} variantSize={variantSize} />}
        </Suspense>
    );
};
